// components/form/PrivacyCheckbox.tsx
'use client';

import React from 'react';
import { clsx } from 'clsx';

export type PrivacyCheckboxProps = {
  checked: boolean;
  onChange: (value: boolean) => void;
  label?: string | React.ReactNode;
  name?: string;
  required?: boolean;
  className?: string;
};

export default function PrivacyCheckbox({
  checked,
  onChange,
  label = (
    <>
      I agree to send my data to ZeroClub solely for communication purposes.
      We will never share your contact details.
    </>
  ),
  name = 'agree',
  required = true,
  className,
}: PrivacyCheckboxProps) {
  return (
    <label className={clsx('relative cursor-pointer select-none flex items-start gap-3', className)}>
      {/* Hidden native checkbox */}
      <input
        type="checkbox"
        name={name}
        className="check-hit"
        checked={checked}
        required={required}
        onChange={(e) => onChange(e.target.checked)}
      />

      {/* Visual checkbox */}
      <span className="check-wrap">
        <span className="check" />
        <svg className="tick" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <polyline
            points="20 6 10 16 6 12"
            stroke="white"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>

      {/* Label text */}
      <span className="font-montserrat text-sm text-white/80 leading-relaxed pl-1">{label}</span>
    </label>
  );
}

